import { makeStyles } from '@material-ui/core';

import { formatShortDate } from '../../../shared/utils/format-date.util';
import { InvitationDetails } from '../../types/invitation.type';
import { InvitationSenderChip } from '../Chips/InvitationSenderChip.component';

type Props = {
  invitation: InvitationDetails;
};

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',

    '& > h2': {
      margin: 0,
    },
  },
});

export function InvitationDetailsHeader({ invitation }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <h2>{invitation.deliveryDate ? `Invitation du ${formatShortDate(invitation.deliveryDate)}` : 'Invitation'}</h2>
      <InvitationSenderChip sender={invitation.sender} />
    </div>
  );
}
